import { TMargin } from '../styles';

export type TWidgetCommonOption = {
    style?: string;
    parentStyleNames?: string[];
    margin?: TMargin;
    isError?: boolean;
    isHide?: boolean;
    /**
     * @deprecated This type is no longer in use and will be removed in a future version. Should use {@link TWidgetCommonOption.isDisabled}
     */
    enabled?: boolean;
    isDisabled?: boolean;
};

export type TViewCommonOption = {
    styleName?: TWidgetCommonOption['style'];
    style?: React.CSSProperties;
} & Pick<TWidgetCommonOption, 'parentStyleNames' | 'isHide' | 'isDisabled' | 'isError' | 'margin'>;

export type TCommonInputOption = {
    inputType?: 'text' | 'number' | 'email' | 'date' | 'password' | 'numericPassword' | 'decimal';
    autofill?: 'phoneNumber' | 'phoneNumberNation' | 'firstName' | 'lastName' | 'country' | 'email' | 'dateOfBirth' | 'otp' | 'postcode' | 'street';
    maxLength?: number;
    onFocus?: boolean;
    isError?: boolean;
} & TWidgetCommonOption;

export type TCommonBottomSheetOption = {
    fullWidth?: boolean;
    fullScreen?: boolean;
    useIconClose?: boolean;
    disableBackdropClick?: boolean;
} & TWidgetCommonOption;
